export const COUNTRIES = {
    GERMANY: 'GERMANY',
    ITALY: 'ITALY',
    PORTUGAL: 'PORTUGAL',
    SPAIN: 'SPAIN',
    NETHERLANDS: 'NETHERLANDS',
    FRANCE: 'FRANCE',
  };
  export const DEFAULT_COUNTRY = COUNTRIES.GERMANY;

  const GERMANY_DOMAINS_REGEXP = [
    /^metro\.de$/,
    /^([a-z-]*\.)*metro\.de$/,
    /^[a-z-]*\.pp-de\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.[a-z-]*\.infra\.metro-markets\.cloud$/,
    /^[a-z-]*\.de\.[a-z0-9-]*\.infra\.metro-markets\.cloud$/,
    /^[a-z-]+\.[a-z-0-9-]+\.infra-de\.(metro-markets\.cloud)$/,
    /^web-app-buyer\.prod\.de\.metro-marketplace\.cloud$/,
  ];

  const ITALY_DOMAINS_REGEXP = [
    /^metro\.it$/,
    /^([a-z-]*\.)*metro\.it$/,
    /^[a-z-]*\.it\.pp-de\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.pp-it\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.it\.[a-z0-9-]*\.infra\.metro-markets\.cloud$/,
    /^[a-z-]+\.[a-z-0-9-]+\.infra-it\.(metro-markets\.cloud)$/,
    /^web-app-buyer\.it\.prod\.de\.metro-marketplace\.cloud$/,
  ];

  const PORTUGAL_DOMAINS_REGEXP = [
    /^makro\.pt$/,
    /^([a-z-]*\.)*makro\.pt$/,
    /^[a-z-]*\.pt\.pp-de\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.pp-pt\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.pt\.[a-z0-9-]*\.infra\.metro-markets\.cloud$/,
    /^[a-z-]+\.[a-z-0-9-]+\.infra-pt\.(metro-markets\.cloud)$/,
    /^web-app-buyer\.pt\.prod\.de\.metro-marketplace\.cloud$/,
  ];

  const SPAIN_DOMAINS_REGEXP = [
    /^makro\.es$/,
    /^([a-z-]*\.)*makro\.es$/,
    /^[a-z-]*\.es\.pp-de\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.pp-es\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.es\.[a-z0-9-]*\.infra\.metro-markets\.cloud$/,
    /^[a-z-]+\.[a-z-0-9-]+\.infra-es\.(metro-markets\.cloud)$/,
    /^web-app-buyer\.es\.prod\.de\.metro-marketplace\.cloud$/,
  ];

  const NETHERLANDS_DOMAINS_REGEXP = [
    /^makro\.nl$/,
    /^([a-z-]*\.)*makro\.nl$/,
    /^[a-z-]*\.nl\.pp-de\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.pp-nl\.metro-marketplace\.cloud$/,
    /^[a-z-]*\.nl\.[a-z0-9-]*\.infra\.metro-markets\.cloud$/,
    /^[a-z-]+\.[a-z-0-9-]+\.infra-nl\.(metro-markets\.cloud)$/,
    /^web-app-buyer\.nl\.prod\.de\.metro-marketplace\.cloud$/,
  ];

const FRANCE_DOMAINS_REGEXP = [
  /^metro\.fr$/,
  /^([a-z-]*\.)*metro\.fr$/,
  /^[a-z-]*\.fr\.pp-de\.metro-marketplace\.cloud$/,
  /^[a-z-]*\.pp-fr\.metro-marketplace\.cloud$/,
  /^[a-z-]*\.fr\.[a-z0-9-]*\.infra\.metro-markets\.cloud$/,
  /^[a-z-]+\.[a-z-0-9-]+\.infra-fr\.(metro-markets\.cloud)$/,
  /^web-app-buyer\.fr\.prod\.de\.metro-marketplace\.cloud$/,
];

  export const COUNTRIES_DOMAINS_REGEXP = {
    GERMANY_DOMAINS_REGEXP,
    ITALY_DOMAINS_REGEXP,
    PORTUGAL_DOMAINS_REGEXP,
    SPAIN_DOMAINS_REGEXP,
    NETHERLANDS_DOMAINS_REGEXP,
    FRANCE_DOMAINS_REGEXP
  };

  export const CORS_ALLOWED_ORIGINS_REGEXP = [
    /https:\/\/marketplace-pp\.metro\.de$/,
    /https:\/\/marketplace-pp\.metro\.it$/,
    /https:\/\/marketplace-pp\.makro\.es$/,
    /https:\/\/marketplace-pp\.makro\.pt$/,
    /https:\/\/marketplace-pp\.makro\.nl$/,
    /https:\/\/marketplace-pp\.makro\.fr$/,
    /https:\/\/www\.metro\.de$/,
    /https:\/\/www\.metro\.it$/,
    /https:\/\/www\.makro\.es$/,
    /https:\/\/www\.makro\.pt$/,
    /https:\/\/www\.makro\.nl$/,
    /https:\/\/www\.metro\.fr$/,
    /https:\/\/www-prod-sc\.metro\.de$/,
    /https:\/\/www-prod-sc\.metro\.it$/,
    /https:\/\/www-prod-sc\.makro\.es$/,
    /https:\/\/www-prod-sc\.makro\.pt$/,
    /https:\/\/www-prod-sc\.makro\.nl$/,
    /https:\/\/www-prod-sc\.metro\.fr$/,
    /https:\/\/idam-pp\.metro\.de$/,
    /https:\/\/idam-pp\.makro\.es$/,
    /https:\/\/idam-pp\.metro\.it$/,
    /https:\/\/idam-pp\.makro\.pt$/,
    /https:\/\/idam-pp\.makro\.nl$/,
    /https:\/\/idam-pp\.metro\.fr$/,
    /https:\/\/idam\.metro\.de$/,
    /https:\/\/idam\.makro\.es$/,
    /https:\/\/idam\.metro\.it$/,
    /https:\/\/idam\.makro\.pt$/,
    /https:\/\/idam\.makro\.nl$/,
    /https:\/\/idam\.metro\.fr$/,
    /\.metro-marketplace.cloud$/,
    /https:\/\/cobrowse-v2\.mypurecloud\.de$/,
    /https:\/\/app\.mypurecloud\.de$/,
  ];

  export const DOMAIN_COUNTRY_CODES = {
    GERMANY: 'de',
    ITALY: 'it',
    PORTUGAL: 'pt',
    SPAIN: 'es',
    NETHERLANDS: 'nl',
    FRANCE: 'fr',
  };

  export const SUPPORTED_COUNTRY_CODES = Object.values(DOMAIN_COUNTRY_CODES);

